import { ColumnsType } from 'antd/es/table';
import { Status } from '../../../components';
import { convertNameToPath, Statuses } from '../../../helper';
import { AnnualReviewUsers } from '../../../types/AnnualReview';
import { Button, Tooltip } from 'antd';
import { FieldTimeOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { userAtom } from '../../../store/atom';
import { Paths } from '../../../routes';
import AuditTrailAnnual from '../../../components/audit-trail-annual';
import { MenteeName } from '../../hr/employee-dashboard/columns';
import { formattedDateTime } from '../../../helper/functions';

export const assignedMenteesAnnualColumns = (): ColumnsType => {
  const location = useLocation();
  const currentUrl = location.pathname;

  return [
    {
      title: 'Mentee',
      key: 'name',
      render: (_, record: AnnualReviewUsers) => (
        <MenteeName
          //@ts-ignore
          data={{ id: record.userId, ...record }}
          path={`${currentUrl}/${convertNameToPath(record.name)}`}
          pathSate={{ userId: record.userId }}
          state={{
            isQuarter: false,
            selectedCycleId: location.state?.selectedCycleId,
          }}
        />
      ),
      sorter: (a: AnnualReviewUsers, b: AnnualReviewUsers) => {
        return a.name?.trim().localeCompare(b.name?.trim());
      },
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
      render: (designation) => designation,
      sorter: (a: AnnualReviewUsers, b: AnnualReviewUsers) => {
        return a.designation?.trim().localeCompare(b.designation?.trim());
      },
    },
    {
      title: 'Tier',
      dataIndex: 'tier',
      key: 'tier',
      render: (tier) => (Number(tier) > 6 ? 'N/A' : tier),
      sorter: (a: AnnualReviewUsers, b: AnnualReviewUsers) => {
        return a.tier
          ?.toString()
          .trim()
          .localeCompare(b.tier?.toString().trim());
      },
    },
    {
      title: 'Mentor Feedback Status',

      key: 'mentorFeedbackStatus',
      sorter: (a: AnnualReviewUsers, b: AnnualReviewUsers) =>
        a.mentorFeedbackStatus
          ?.trim()
          .localeCompare(b.mentorFeedbackStatus?.trim()),
      render: (data: AnnualReviewUsers) => {
        if (data.mentorFeedbackStatus === Statuses.Completed) {
          return (
            <>
              <Status status={data.mentorFeedbackStatus} />
              {data.mentorSubmissionDate && (
                <div className="w-fit">
                  <p className="text-gray-500 bg-gray-100 rounded-lg text-sm text-center py-1 px-3">
                    On {formattedDateTime(data.mentorSubmissionDate)}
                  </p>
                </div>
              )}
            </>
          );
        }
        return <Status status={data.mentorFeedbackStatus} />;
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (data: AnnualReviewUsers) => (
        <>
          <div className="flex items-center space-x-2">
            <AnnualCycle
              data={{
                id: data.userId,
                name: data.name,
                tier: data.tier,
                designation: data.designation,
                mentor: {
                  ...data.mentor,
                  tier: extractNumber(data.mentor.tier as string),
                },
              }}
            />

            <ViewAudit id={data.userReviewId as string} />
          </div>
        </>
      ),
    },
  ];
};

const ViewAudit = ({ id }: { id: string }) => {
  const [open, setOpen] = useState(false);
  const hanldeClick = () => setOpen(true);
  return (
    <Tooltip title="View History" placement="top">
      <Button icon={<FieldTimeOutlined />} onClick={hanldeClick} />
      <AuditTrailAnnual setOpen={setOpen} open={open} id={id} />
    </Tooltip>
  );
};

const AnnualCycle = ({ data }: { data: any }) => {
  const [userState, setUserState] = useAtom(userAtom);
  const navigate = useNavigate();

  const handleClick = () => {
    setUserState({
      ...userState,
      selectedMentee: data,
    });

    navigate(
      `${Paths.MentorAnnualMenteesFeedback}/${convertNameToPath(data?.name || '')}/annual-feedback`,
      { state: { from: 'mentor' } }
    );
  };

  return (
    <Button
      type="text"
      style={{
        backgroundColor: '#E7F5FF',
        border: '1px solid #228BE6',
        color: '#228BE6',
      }}
      onClick={handleClick}
    >
      View Current Annual Review
    </Button>
  );
};

const extractNumber = (label: string): string | null => {
  if (typeof label !== 'string') {
    return null;
  }
  const match = label.match(/\d+/);
  return match ? match[0] : null;
};
